import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";
import Section from "./Section";

function Hero() {

  return (<>
    <Section>
      <Container maxWidth="md" sx={{
        marginBottom: 3,
      }}>
        <Box sx={{
          position: 'relative',
          maxHeight: '80vh',
          overflow: 'hidden',
        }}>
          <video id="background-video" loop autoPlay muted style={{
          }}>
            <source src="/video/schronisko.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <Box sx={{
            position: 'absolute',
            left: 20,
            top: 20,
          }}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              <Typography variant="h2" fontWeight='bold'
                sx={{
                  fontSize: { xs: '1.0rem', sm: '2rem', md: '2.5rem', lg: '3rem' },
                }}
                // className="text-white-shadow"
              >
                Zmysły. Przestrzeń. Intencja.
              </Typography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 2 }}
            >
              <Typography variant="body2" sx={{
                display: { xs: "none", sm: "flex" },
              }}
                // className="text-white-shadow"
              >
                Tworzę przestrzenie, które inspirują, rozwijają i pozostają w pamięci. <br />
                Łączę architekturę, technologię i ludzką wrażliwość, aby budować <br />
                przyszłość odpowiedzialną, zrównoważoną i piękną.
              </Typography>
            </motion.div>
          </Box>
        </Box>
      </Container>
    </Section>
  </>
  );
}

export default Hero;
